document.addEventListener("DOMContentLoaded", function() {
    const wrapper = document.querySelector('.swipe-wrapper-review');
    let interval = 7000; // 7 seconds
    let currentIndex = 0;
    let totalImages = wrapper.querySelectorAll('img').length;

    let startX, moveX, currentTranslateX = 0;
    let isDragging = false;

    function setWrapperTranslate(x) {
        wrapper.style.transform = `translateX(${x}%)`;
    }

    function nextImage() {
        currentIndex = (currentIndex + 1) % totalImages;
        currentTranslateX = -currentIndex * 100;
        setWrapperTranslate(currentTranslateX);
    }

    function handleTouchStart(e) {
        startX = e.touches[0].clientX;
        isDragging = true;
    }

    function handleTouchMove(e) {
        if (!isDragging) return;
        moveX = e.touches[0].clientX;
        let movePercentage = (moveX - startX) / wrapper.offsetWidth * 100;
        setWrapperTranslate(currentTranslateX + movePercentage);
    }

    function handleTouchEnd() {
        if (!isDragging) return;
        isDragging = false;

        let endTranslateX = -currentIndex * 100;
        if (Math.abs(moveX - startX) > 50) { // Swipe threshold
            if (moveX > startX) { // Right swipe
                currentIndex = Math.max(0, currentIndex - 1);
            } else { // Left swipe
                currentIndex = Math.min(totalImages - 1, currentIndex + 1);
            }
            endTranslateX = -currentIndex * 100;
        }
        currentTranslateX = endTranslateX;
        setWrapperTranslate(currentTranslateX);
    }

    wrapper.addEventListener('touchstart', handleTouchStart);
    wrapper.addEventListener('touchmove', handleTouchMove);
    wrapper.addEventListener('touchend', handleTouchEnd);

    setInterval(nextImage, interval);
});
